import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable(
)
export class ExportExcelService {

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  constructor(
    private http: HttpClient
  ) { }
  public exportExcel(jsonData: any[], fileName: string): void {

    let ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    let wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    FileSaver.saveAs(data, fileName + this.fileExtension);
  }

  saveFile(blob, fileName, path?) {
    if (path) {
      // FileSaver.saveAs(path, fileName);
      this.downloadFile(path, 1).subscribe(res => {
        const data: Blob = new Blob([res.body], { type: res.body.type });
        FileSaver.saveAs(data, fileName);
      })
    }
    else {
      const data: Blob = new Blob([blob], { type: blob.type });
      FileSaver.saveAs(data, fileName);
    }

  }


  importFromFilepath(filepath) {
    return this.http.get(filepath, { responseType: 'blob', observe: 'response' })
  }

  downloadFile(filepath, original_flag) {

    return this.http.get(filepath, {
      params: {
        original_type: original_flag || 1
      },
      responseType: 'blob', observe: 'response'
    }
    )
  }

  getDocxBase64(file, filepath) {
    let obj = [];
    obj.push(file)
    return this.http.post(environment.SERVER_URL + 'Document/Converter', obj, {
      params: {
        file_path: filepath || ''
      }
    })
  }
}


